import { Component } from '@angular/core'
import { InvitationTrackerStatisticsComponent } from '../invitation-tracker-statistics/invitation-tracker-statistics.component'

@Component({
  selector: 'app-invitation-tracker-loading',
  standalone: true,
  imports: [InvitationTrackerStatisticsComponent],
  templateUrl: './invitation-tracker-loading.component.html'
})
export class InvitationTrackerLoadingComponent {
  public readonly tabPlaceholders = [88, 104, 72, 96]
  public readonly filterPlaceholders = [1, 2, 3, 4]
  public readonly tableRows = [1, 2, 3, 4, 5, 6]
}
